import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faDown, faCircle, faFlag } from '@fortawesome/pro-regular-svg-icons';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-slider',
  imports: [RouterModule, NgOptimizedImage, FontAwesomeModule],
  templateUrl: './slider.component.html',
  styleUrl: './slider.component.scss',
  standalone: true
})
export class SliderComponent {
  constructor(
    private icon: FaIconLibrary
  ) {
    icon.addIcons(faDown, faCircle, faFlag);
  }

}
